export { FeedbackCollectorModal } from "./feedback-collector-modal";
